import { WidgetType } from '@/api/rest/resources/types/widget';
// eslint-disable-next-line import/no-cycle
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useActiveWidgetSlotConfiguration } from '@/hooks/useWidgetConfigurationByOrganizationId';

export const ScenarioMethodologyDetails = () => {
  const defaultConfiguration = useActiveWidgetSlotConfiguration(
    'default_scenario_modelling_methodology_inputs_tab',
    WidgetType.a_stack,
  );
  return <WidgetSlotRenderer nestedWidget={defaultConfiguration} />;
};
